import React, { Component } from "react";
import Modal from "react-modal";
import "../../../src/styles/modalSubmitCountry.scss";
import continentCountryData from "./Data/continentCountryData.js";
import "../../styles/scroll.scss";

export default class ModalSubmitCountry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      correctAnswer: undefined,
      answered: false
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // to change text color in modal
    //this.subtitle.style.color = '#000000';
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  isCorrectCountry = country => {
    document.getElementById("disable-country-buttons").className =
      "disable-click";

    if (this.props.compareCountry(country)) {
      this.setState({ correctAnswer: true, continueScoreBoard: true });
    } else {
      this.setState({ correctAnswer: false });
    }
    localStorage.setItem("answered", "true");
    localStorage.setItem("continueScoreBoard", "true");
  };

  hasAnswered = () => {
    if (this.state.correctAnswer === undefined) {
      return null;
    } else if (this.state.correctAnswer === true) {
      return (
        <div className="Welcome-modal-container">
          <div className="world-map-subtext">
            <div>
              <h1 style={{ color: "green" }}>Correct!</h1>
              <h4>
                It was{" "}
                <span style={{ fontWeight: 600 }}>
                  {this.props.currentCoordinates.country}{" "}
                </span>
                . Well done!
              </h4>
            </div>

            <button
              className="cta-button-continue"
              onClick={() => {
                this.closeModal();
                this.props.goToScoreBoardLvlOne();
              }}
            >
              Continue!
            </button>
          </div>
        </div>
      );
    } else if (this.state.correctAnswer === false) {
      return (
        <div className="Welcome-modal-container">
          <div className="world-map-subtext">
            <div>
              <h1 style={{ color: "red" }}>Incorrect!</h1>
              <h4>
                The correct answer was{" "}
                <span style={{ fontWeight: 600 }}>
                  {this.props.currentCoordinates.country}.
                </span>
              </h4>
            </div>
            <button
              className="cta-button-continue"
              onClick={() => {
                this.closeModal();
                this.props.goToScoreBoardLvlOne();

                //rest state to next round
                this.props.readyToAnswerAgainCountry();
              }}
            >
              Continue!
            </button>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <Modal
          className="Modal-content-country"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldFocusAfterRender={false}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Example Modal"
        >
          <div className="Welcome-modal-container-country">
            <button
              className="button-close-country"
              onClick={() => {
                this.closeModal();
                this.props.readyToAnswerAgainCountry();
              }}
              //If user has clicked the map, hide the button. Using opacity is IMPORTANT because otherwise the space for button on page isn't reserved and entire page jumps.
              style={this.state.answered ? { opacity: 0 } : { opacity: 1 }}
              disabled={this.state.answered}
            >
              <span aria-hidden="true">×</span>
            </button>
            <center>
              <h2 className="countries-head">
                {"  "}
                Which country in
                <span style={{ color: "#52b452dc" }}>
                  {" "}
                  &nbsp;{this.props.currentCoordinates.continent}&nbsp;{" "}
                </span>{" "}
                are you in?
              </h2>
            </center>

            <div>
              <center>
                <p className="modal-header__subtext-countries">
                  Click on the country below that you think you are currently
                  in, based on what you saw in your environment.
                  <span style={{ fontWeight: 600 }}>
                    {" "}
                    Think closely, as you have only one guess.
                  </span>
                </p>
              </center>
            </div>

            <div className="think-closely-country-mobile">
              <center>
                <span style={{ fontWeight: 600 }}>
                  Think closely, as you have only one guess.
                </span>
              </center>
            </div>

            {/* Här genereras knapparna som innehåller alla länder */}

            <div id="disable-country-buttons">
              <div className="Country-buttons-container">
                {continentCountryData()[
                  this.props.currentCoordinates.continent
                ].map((item, i) => (
                  <button
                    className={
                      !this.state.answered
                        ? "cta-country-button"
                        : "cta-country-button cta-country-button--after-clicked cta-country-button--correct"
                    }
                    onClick={() => {
                      this.isCorrectCountry(item);
                      this.setState({ answered: true });
                    }}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>
            <center>
              <div class="arrows" />
            </center>

            {/*} Prints correct or wrong answer to the user!! */}

            <div className="world-map-subtext-correct">
              {this.state.correctAnswer === undefined && (
                <div
                  style={
                    this.state.correctAnswer === undefined
                      ? { opacity: 0 }
                      : { opacity: 1 }
                  }
                >
                  <h1 style={{ color: "green" }}>Correct!</h1>
                  <h4>
                    It was{" "}
                    <span style={{ fontWeight: 600 }}>
                      {this.props.currentCoordinates.country}{" "}
                    </span>
                    . Well done!
                  </h4>
                </div>
              )}
              {this.state.correctAnswer === true && (
                <div>
                  <h1 style={{ color: "green" }}>Correct!</h1>
                  <h4>
                    It was{" "}
                    <span style={{ fontWeight: 600 }}>
                      {this.props.currentCoordinates.country},{" "}
                      {this.props.currentCoordinates.city}
                    </span>
                    . Well done!
                  </h4>
                </div>
              )}

              {this.state.correctAnswer === false && (
                <div>
                  <h1 style={{ color: "red" }}>Incorrect!</h1>
                  <h4>
                    The correct answer was{" "}
                    <span style={{ fontWeight: 600 }}>
                      {this.props.currentCoordinates.country},{" "}
                      {this.props.currentCoordinates.city}.
                    </span>
                  </h4>
                  <h4>
                  <span style={{ fontSize: 16 }}>
                      You were{" "}
                      <span style={{ fontWeight: 600 }}>
                        {this.props.distanceCountry}
                      </span>{" "}
                      km far away.
                      </span>
                  </h4>
                </div>
              )}
            </div>

            <div className="Mini-text-country-mobile">
              {" "}
              <center>
                <span style={{ color: "lightgrey" }}> Continent &nbsp;</span>{" "}
                <span style={{ fontWeight: 600 }}> -> &nbsp;Country </span>
              </center>
            </div>

            <div className="modal-content-footer-country">
              <h1 className="modal-score-country">
                Total score
                <span style={{ color: "#52b452dc" }}>
                  &nbsp; {this.props.totalScore}{" "}
                </span>
              </h1>

              <div>
                <p className="Mini-text-country">
                  {" "}
                  <span style={{ color: "lightgrey" }}>
                    {" "}
                    Continent &nbsp;
                  </span>{" "}
                  <span style={{ fontWeight: 600 }}> -> &nbsp;Country </span>
                </p>
              </div>

              <div className="modal-button--continue">
                <button
                  className="modal-button-continue-country"
                  onClick={() => {
                    this.closeModal();
                    this.props.goToScoreBoardLvlOne();
                  }}
                  disabled={this.state.correctAnswer === undefined}
                >
                  {" "}
                  Continue{" "}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
